export const languages = [
  { lang: 'pt_BR', label: 'Português (Brasil)', acceptLanguage: 'PT_br' },
  { lang: 'en_US', label: 'English', acceptLanguage: 'EN-us' },
  { lang: 'es_AR', label: 'Español (Argentina)', acceptLanguage: 'ES-ar' },
  { lang: 'es_CL', label: 'Español (Chile)', acceptLanguage: 'ES-cl' },
];

export const defaultLanguage = 'pt_BR';
